import { theme as defaultTheme } from "@/scss/_theme.js";

/**
 * Converts a CSS hex color string to a Three.js-compatible integer.
 * e.g. "#1fdb9b" → 0x1fdb9b
 */
const hexToThree = (hex) => parseInt(hex.replace("#", ""), 16);

export const viewerColors = {
  // Theme-aware colors
  POINT_COLOR: hexToThree(defaultTheme.viewerPointColor),
  SELECTED_POINT_COLOR: hexToThree(defaultTheme.viewerSelectedPointColor),
  MIDPOINT_COLOR: hexToThree(defaultTheme.viewerMidpointColor),
  MEASUREMENT_POINT_COLOR: hexToThree(defaultTheme.viewerMeasurementPointColor),
  ZOOM_POINT_COLOR: hexToThree(defaultTheme.primary),
  RESTRICTED_AREA_COLOR: hexToThree(defaultTheme.viewerRestrictedAreaColor),
  SELECTED_LINE_COLOR: hexToThree(defaultTheme.viewerSelectedLineColor),
  OUTLINR_COLOR: hexToThree(defaultTheme.viewerOutlineColor),

  // Theme-invariant colors (same across all themes)
  MOUNTING_SURFACE_COLOR: 0x7e8884,
  SOLAR_POINT_COLOR: 0xe8e9e9,
  MARGIN_COLOR: 0x6cb0ff,
};


export function initViewerColors(theme) {
  viewerColors.POINT_COLOR = hexToThree(theme.viewerPointColor);
  viewerColors.SELECTED_POINT_COLOR = hexToThree(theme.viewerSelectedPointColor);
  viewerColors.MIDPOINT_COLOR = hexToThree(theme.viewerMidpointColor);
  viewerColors.MEASUREMENT_POINT_COLOR = hexToThree(theme.viewerMeasurementPointColor);
  viewerColors.ZOOM_POINT_COLOR = hexToThree(theme.primary);
  viewerColors.RESTRICTED_AREA_COLOR = hexToThree(theme.viewerRestrictedAreaColor);
  viewerColors.SELECTED_LINE_COLOR = hexToThree(theme.viewerSelectedLineColor);
  viewerColors.OUTLINR_COLOR = hexToThree(theme.viewerOutlineColor);
}
